import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {Test} from '../models/test/test';
import {BehaviorSubject, Observable} from 'rxjs';
import {TestService} from '../../services/api/test.service';
import {TestFilters} from '../models/filters/test-filters';

export class TestsDataSource implements DataSource<Test> {

  private testsSubject = new BehaviorSubject<Test[]>([]);
  private totalElementsSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(true);

  public totalElements$ = this.totalElementsSubject.asObservable();
  public loading$ = this.loadingSubject.asObservable();

  constructor(
    private testService: TestService,
  ) {
  }

  connect(collectionViewer: CollectionViewer): Observable<Test[]> {
    return this.testsSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.testsSubject.complete();
    this.totalElementsSubject.complete();
    this.loadingSubject.complete();
  }

  loadTests(
    filters: TestFilters,
    sort: any[], pageSize: number, pageNumber: number,
  ): void {

    this.loadingSubject.next(true);

    this.testService.searchTests(filters, sort, pageSize, pageNumber)
      .then(page => {
        this.testsSubject.next(page.content);
        this.totalElementsSubject.next(page.totalElements);
      })
      .catch(error => {
        this.testsSubject.next([]);
        this.totalElementsSubject.next(0);
      })
      .finally(() => {
        this.loadingSubject.next(false);
      });
  }

  insertTest(test: Test): void {
    this.testsSubject.next([test, ...this.testsSubject.getValue()]);
  }

}
